// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/welcome-frontend/" + {"220":"P6Bx","235":"uurv","380":"yaP1","382":"K_VX","410":"PzS-","450":"mf3M","458":"os6v"}[chunkId] + "-" + {"220":"55614529dcea","235":"af24f1e7a677","380":"ad9b8bb746f3","382":"30759bd65124","410":"1e916561ca78","450":"a6074a55a091","458":"9399d8e04ff4"}[chunkId] + ".css";
};